// import { useMutation, useQuery } from "@tanstack/react-query";
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useStockApi } from '../../Hooks/useStockApi';

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useGetAllStocks = (queryParams: Params) => {
 
  const { getAllStocks } = useStockApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: [
      'getStocks',
      queryParams
    ],
    queryFn: () => {
      return getAllStocks(queryParams);
    },
    retry: false,
  });

  return {
    data,
    isLoading:isFetching || isRefetching,
    refetch
  };
};

export const useEditStockQuantity = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getEditStockQuantity } = useStockApi();

  return useMutation({
    mutationKey: ['EditQuantity'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      getEditStockQuantity(id, data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Quantity Updated successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getStocks'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          'Failed to update the Quantity',
        'error'
      );
    },
  });
};
